import { EnsureVorgangId } from '../../amplify/backend/function/data/lib/persistence/vorgangService';
import { Datei, Vorgang, Zahlungseingang } from '../types';
import { DateiKategorie, Status } from './constants';
import { MEHRWERTSTEUER } from './domain/vorgang';

export function berechneGesamtzahlungsbetrag(zahlungseingang: Array<Zahlungseingang>): number {
  let summe = 0;
  for (const betrag of zahlungseingang.map((eingang) => eingang.betrag)) {
    summe += betrag;
  }
  return summe;
}

export function berechneOffenenBetrag(zahlungseingang: Array<Zahlungseingang>): number {
  return berechneGesamtzahlungsbetrag(zahlungseingang);
}

// Differenz Erstzulassung zur Bauzeit des Marktindex ist größer als 1 Jahr
export function diffErstzulassungZurBauzeitDesMarktindexGroesserEinJahr(vorgang: Vorgang): boolean {
  return vorgang?.fahrzeugdaten?.phantomkalkulation && vorgang?.fahrzeugdaten?.containerName ? true : false;
}

export type PartialVorgang = EnsureVorgangId<Partial<Pick<Vorgang, 'status' | 'zahlungseingang' | 'dateien' | 'rechnungsnummern' | 'rechnungen'>>>;

export function aktualisiereStatus(vorgang: PartialVorgang) {
  const rechnungen = holeRechnungen(vorgang);
  const zahlungsbetrag = Math.round(berechneGesamtzahlungsbetrag(holeZahlungseingaengeZuRechnungen(vorgang, rechnungen)) * 100) / 100;
  const rechnungsbetrag = Math.round((rechnungen.reduce((sum, datei) => sum + (datei.wert ?? 0), 0) ?? 0) * (MEHRWERTSTEUER / 100 + 1) * 100) / 100;

  const differenz = Math.abs(zahlungsbetrag - rechnungsbetrag);
  const toleranz = 0.02; // Toleranz für Rundungsdifferenzen bei MwSt-Berechnung

  if (differenz <= toleranz || zahlungsbetrag >= rechnungsbetrag) {
    console.log(`setze Status auf ABGESCHLOSSEN: ${vorgang.status}, ${zahlungsbetrag}, ${rechnungsbetrag}, Differenz: ${differenz}`);
    return Status.ABGESCHLOSSEN;
  } else {
    console.log(`setze Status auf MAHNWESEN: ${vorgang.status}, ${zahlungsbetrag}, ${rechnungsbetrag}, Differenz: ${differenz}`);
    return Status.MAHNWESEN;
  }
}

export const holeRechnungen = (vorgang: PartialVorgang) => {
  return vorgang.dateien?.filter((datei) => datei.kategorien?.includes(DateiKategorie.RECHNUNG)) ?? [];
};

export const holeStorno = (vorgang: PartialVorgang) => {
  return vorgang.dateien?.filter((datei) => datei.kategorien?.includes(DateiKategorie.STORNO)) ?? [];
};

export const holeZahlungseingaengeZuRechnungen = (vorgang: PartialVorgang, rechnungen: Datei[]) => {
  const rechnungsnummern = rechnungen.map((rechnung) => rechnung.dateiname?.replace(/\.pdf$/i, ''));
  return vorgang.zahlungseingang?.filter((zahlungseingang) => rechnungsnummern.includes(zahlungseingang.rechnungsnummer)) ?? [];
};
